/**
 * Moneris Hosted Tokenization configuration.
 * URLs and origin are read from environment variables (.env / .env.production).
 */
import environment from '../config/appConfig';

/**
 * Resolved Moneris iframe URL for the current environment.
 */
export const MONERIS_BASE_URL = environment.monerisIframeUrl;

/**
 * Resolved Moneris origin for postMessage validation.
 */
export const MONERIS_ORIGIN = environment.monerisOrigin;

/**
 * Default iframe parameters.
 */
export const MONERIS_IFRAME_DEFAULTS = Object.freeze({
  pmmsg: 'true',
  display_labels: '2',
  enable_exp: '1',
  enable_cvd: '1',
  enable_exp_formatting: '1',
  enable_cc_formatting: '1',
  css_body: 'background:transparent;font-family:IBM Plex Sans,sans-serif;padding:12px;font-size:14px;',
  css_textbox:
    'border:1.5px solid #d1d9e0;border-radius:8px;padding:12px 14px;font-size:14px;width:100%;box-sizing:border-box;margin-bottom:12px;outline:none;transition:border-color 0.2s;color:#061A2F;background:#ffffff;font-family:IBM Plex Sans,sans-serif;',
  css_textbox_pan: 'width:100%;',
  css_textbox_exp: 'width:100%;',
  css_textbox_cvd: 'width:100%;',
  pan_label: 'Card Number',
  exp_label: 'Expiry (MM/YY)',
  cvd_label: 'CVD',
});

/**
 * Moneris Hosted Tokenization response codes.
 */
export const MONERIS_RESPONSE_CODES = Object.freeze({
  SUCCESS: '001',
  INVALID_PROFILE_ID: '940',
  TOKEN_GENERATION_ERROR: '941',
  INVALID_PROFILE_OR_SOURCE: '942',
  INVALID_CARD_DATA: '943',
  INVALID_EXPIRY: '944',
  INVALID_CVD: '945',
});
